export const common = {
  nav: {
    services: 'Servicios',
    packages: 'Paquetes',
    about: 'Nosotros',
    testimonials: 'Testimonios',
    bookNow: 'Reservar Ahora',
    phone: '+34 643 939 427',
  },
  hero: {
    badge: 'Servicios Premium para el Hogar Desde 2020',
    title: 'Transforma Tu Espacio en un Sanctuary',
    subtitle: 'Diseño interior experto, limpieza meticulosa, mantenimiento confiable y renovaciones personalizadas—todo bajo un mismo techo',
    exploreServices: 'Explorar Servicios',
    viewPackages: 'Ver Paquetes',
  },
  services: {
    title: 'Nuestra Experiencia',
    subtitle: 'Soluciones integrales para el hogar adaptadas a tu estilo de vida',
    learnMore: 'Saber Más',
    interiorDesign: 'Diseño de Interiores',
    cleaning: 'Limpieza',
    maintenance: 'Mantenimiento',
    renovation: 'Renovación',
  },
  pricing: {
    title: 'Precios de Servicios',
    subtitle: 'Precios transparentes para todos los tamaños de propiedad',
    serviceType: 'Tipo de Servicio',
    bedroom1: '1 Dormitorio',
    bedroom2: '2 Dormitorios',
    bedroom3: '3 Dormitorios',
    villa: 'Villa',
    cleaningServices: 'Servicios de Limpieza',
    cleaningDesc: 'Limpieza post-estancia',
    maintenance: 'Mantenimiento',
    maintenanceDesc: 'Revisiones de plomería y reparaciones menores',
    interiorDesign: 'Diseño de Interiores',
    interiorDesignDesc: 'Consulta de diseño',
    perMonth: 'por mes',
    allPricesInclude: 'Todos los precios incluyen características y servicios estándar',
    getQuote: 'Obtener Cotización',
  },
  packages: {
    badge: 'Paquetes Seleccionados',
    title: 'Paquetes de Servicios',
    subtitle: 'Soluciones prediseñadas para alquileres vacacionales y residentes permanentes',
    selectPackage: 'Seleccionar Paquete',
    perService: '/ por servicio',
    perMonth: '/ mes',
    customPricing: 'El precio depende del alcance del proyecto',
    mostPopular: 'Más Popular',
    bestValue: 'Mejor Valor',
    bookService: 'Reservar Servicio',
    includes: 'Incluye:',
    serviceColumns: {
      cleaning: {
        title: 'Servicios de Limpieza',
        subtitle: 'Apartamentos y Villas',
        description: 'Nuestro servicio de limpieza garantiza que su propiedad esté lista para los huéspedes, higiénica y mantenida profesionalmente.',
        includes: [
          'Limpieza post-estancia para alquileres vacacionales',
          'Limpieza profunda de todas las habitaciones',
          'Limpieza de cocina (superficies, electrodomésticos, exterior de armarios)',
          'Sanitización de baños (inodoros, duchas, lavabos, espejos)',
          'Limpieza de pisos (barrido, trapeado, aspirado)',
          'Desempolvado de muebles y superficies',
          'Cambio de ropa de cama y coordinación de lavandería',
          'Reposición de artículos esenciales (papel higiénico, jabón, suministros básicos)',
          'Inspección final para garantizar condición lista para huéspedes',
        ],
      },
      maintenance: {
        title: 'Servicios de Mantenimiento',
        subtitle: 'Preventivo y Correctivo',
        description: 'Nuestro servicio de mantenimiento mantiene su propiedad funcional, segura y sin problemas, evitando costosas reparaciones de emergencia.',
        includes: [
          'Revisiones de fontanería y reparaciones menores (fugas, grifos, desagües)',
          'Inspecciones eléctricas y pequeñas reparaciones (interruptores, luces, enchufes)',
          'Inspección de aire acondicionado y limpieza de filtros',
          'Revisión de electrodomésticos (lavadora, nevera, horno, caldera)',
          'Ajuste de puertas, ventanas, cerraduras y bisagras',
          'Reparaciones menores de carpintería',
          'Retoques de pintura y reparaciones de paredes',
          'Reparaciones generales de desgaste',
          'Revisiones regulares del estado de la propiedad e informes',
        ],
      },
      interiorDesign: {
        title: 'Servicios de Diseño Interior y Renovación',
        subtitle: null,
        description: 'Nuestro servicio de diseño interior y renovación mejora la comodidad, estética y valor de alquiler de su propiedad.',
        includes: [
          'Consulta de diseño interior',
          'Planificación de espacios y optimización de distribución',
          'Selección y colocación de muebles',
          'Recomendaciones y mejoras de iluminación',
          'Paletas de colores y selección de materiales',
          'Estilismo y puesta en escena para alquileres vacacionales',
          'Mejoras estéticas listas para alquiler',
          'Actualizaciones estacionales de decoración',
          'Coordinación de trabajos de renovación (pintura, carpintería, pequeñas mejoras)',
        ],
      },
      renovation: {
        title: 'Renovación',
        subtitle: 'Ligera a Media',
        description: 'Para mejoras y actualizaciones sin construcción completa.',
        includes: [
          'Pintura y acabados de paredes',
          'Mejoras de carpintería (armarios, estanterías, soluciones personalizadas)',
          'Mejoras de cocina y baño',
          'Mejoras de pisos',
          'Mejoras funcionales y estéticas',
          'Coordinación de proyectos con profesionales locales de confianza',
        ],
      },
    },
    items: {
      postStay: {
        name: 'Renovación Pre/Post-Estancia',
        features: [
          'Limpieza profunda (3–4 horas)',
          'Cambio de ropa de cama y lavandería',
          'Reparaciones menores y retoques',
          'Reposición de artículos esenciales',
          'Inspección rápida de la propiedad',
        ],
      },
      villaPrep: {
        name: 'Preparación de Villa Pre/Post Estancia',
        features: [
          'Consulta de estilismo interior',
          'Limpieza profunda completa',
          'Revisión de mantenimiento',
          'Configuración de bienvenida y puesta en escena',
          'Inspección de la propiedad',
        ],
      },
      monthlyRefresh: {
        name: 'Renovación Mensual del Hogar',
        features: [
          '2–4 visitas por mes',
          'Visitas de limpieza semanales o quincenales',
          'Revisión básica de mantenimiento',
          'Revisión de electrodomésticos',
          'Hogar ordenado e higiénico',
        ],
      },
      interiorDesign: {
        name: 'Diseño de Interiores y Estilismo',
        features: [
          'Consulta con expertos en diseño de Art Throng',
          'Estilismo interior completo o pequeñas actualizaciones para residentes o alquileres',
          'Integración con horarios de limpieza y mantenimiento',
          'Puesta en escena opcional para alquileres vacacionales',
        ],
      },
    },
  },
  booking: {
    title: 'Reserva Tu Servicio',
    subtitle: 'Completa el formulario y nos pondremos en contacto contigo pronto',
    form: {
      service: 'Seleccionar Servicio',
      servicePlaceholder: 'Elige un servicio',
      date: 'Fecha Preferida',
      time: 'Hora Preferida',
      frequency: 'Frecuencia',
      frequencyPlaceholder: 'Selecciona la frecuencia',
      name: 'Nombre Completo',
      namePlaceholder: 'Tu nombre',
      email: 'Correo Electrónico',
      emailPlaceholder: 'tu@email.com',
      phone: 'Teléfono',
      phonePlaceholder: 'Tu número de teléfono',
      message: 'Mensaje (Opcional)',
      messagePlaceholder: 'Cuéntanos sobre tus necesidades...',
      submit: 'Enviar Reserva',
      submitting: 'Enviando...',
      success: '¡Reserva enviada con éxito! Nos pondremos en contacto pronto.',
      error: 'Algo salió mal. Por favor, inténtalo de nuevo.',
    },
    services: {
      interior: 'Diseño de Interiores',
      cleaning: 'Limpieza del Hogar',
      maintenance: 'Mantenimiento',
      renovation: 'Renovación y Carpintería',
    },
    frequencies: {
      oneTime: 'Una Vez',
      weekly: 'Semanal',
      biweekly: 'Quincenal',
      monthly: 'Mensual',
    },
  },
  about: {
    badge: 'Quiénes Somos',
    title: 'Nuestro Equipo',
    paragraph1: 'Art Throng ofrece soluciones completas de diseño interior y exterior, brindando lujo accesible y adaptándose a todos los estilos de diseño para clientes en todas las Islas Canarias.',
    paragraph2: 'Hemos estado establecidos en Fuerteventura durante los últimos cinco años, construyendo una presencia local confiable y reuniendo un equipo capacitado de carpinteros, albañiles, pintores, y ahora especialistas en limpieza y mantenimiento para apoyar cada etapa de tu proyecto.',
    paragraph3: 'Nuestro equipo es multilingüe, con fluidez en inglés, español e italiano, asegurando una comunicación fluida para clientes de cualquier lugar. En Art Throng, combinamos creatividad, experiencia y conocimiento local para entregar espacios que son hermosos, funcionales y adaptados a tu estilo y necesidades.',
    subtitle: 'Art Throng Home nació de la pasión por crear espacios hermosos y funcionales. Con años de experiencia en diseño de interiores y gestión de propiedades, entendemos lo que se necesita para mantener un hogar impecable.',
    items: {
      expertise: {
        title: 'Experiencia en Interiores',
        description: 'Nuestro equipo combina habilidades de diseño con conocimiento práctico del cuidado del hogar',
      },
      staff: {
        title: 'Personal Profesional',
        description: 'Todos los miembros del equipo están verificados, capacitados y comprometidos con la excelencia',
      },
      experience: {
        title: 'Experiencia Premium',
        description: 'Atención personalizada y servicio de alta calidad en cada interacción',
      },
    },
  },
  testimonials: {
    title: 'Lo Que Dicen Nuestros Clientes',
    subtitle: 'Historias reales de hogares transformados',
    transformationGallery: 'Galería de Transformaciones',
    verified: 'Verificado',
    testimonialsList: [
      {
        name: 'María González',
        location: 'Propietaria de Villa, Corralejo',
        text: 'Art Throng Home transformó completamente nuestro alquiler vacacional. Su equipo de diseño de interiores creó un espacio impresionante que a nuestros huéspedes les encanta, y su servicio de limpieza lo mantiene impecable entre reservas. ¡Muy recomendado!',
      },
      {
        name: 'Carlos Rodríguez',
        location: 'Propietario, Caleta de Fuste',
        text: 'El paquete de renovación mensual del hogar ha sido un cambio total para nuestra familia ocupada. Profesional, confiable y siempre minucioso. El equipo siempre va más allá.',
      },
      {
        name: 'Laura Martínez',
        location: 'Administradora de Propiedades, Costa Calma',
        text: 'Gestionar múltiples propiedades es estresante, pero Art Throng Home lo hace fácil. Su servicio de renovación post-estancia es increíblemente eficiente, y la calidad es consistentemente excelente. ¡Vale cada euro!',
      },
      {
        name: 'Javier Hernández',
        location: 'Propietario, Morro Jable',
        text: 'Desde la renovación hasta el mantenimiento regular, manejan todo con profesionalismo. El trabajo de carpintería que hicieron en nuestra oficina en casa es excepcional. ¡Verdaderos artesanos!',
      },
    ],
    transformations: {
      livingRoom: {
        label: 'Transformación de Sala de Estar',
        description: 'Renovación completa de sala de estar con muebles modernos, paleta de colores neutros e iluminación mejorada. Transformada de un espacio anticuado a un santuario contemporáneo perfecto para relajarse y entretener.',
      },
      kitchen: {
        label: 'Renovación de Cocina',
        description: 'Remodelación de cocina moderna con gabinetes blancos elegantes, encimeras de mármol y electrodomésticos de acero inoxidable. Una transformación completa que combina funcionalidad con diseño elegante.',
      },
      bedroom: {
        label: 'Renovación de Dormitorio',
        description: 'Transformación de dormitorio tranquilo con tonos neutros, ropa de cama elegante y decoración cuidadosa. Creado un santuario sereno perfecto para el descanso y la relajación.',
      },
      bathroom: {
        label: 'Mejora de Baño',
        description: 'Renovación de baño tipo spa de lujo con accesorios modernos, azulejos elegantes e iluminación sofisticada. Transformado en un retiro relajante con diseño limpio y minimalista.',
      },
      before: 'Antes',
      after: 'Después',
      bookSimilar: 'Reservar Servicio Similar',
    },
  },
  contact: {
    badge: 'Contáctanos',
    title: 'Hablemos',
    subtitle: 'Estamos aquí para responder tus preguntas y ayudarte a comenzar',
    form: {
      name: 'Nombre',
      namePlaceholder: 'Tu nombre',
      email: 'Correo Electrónico',
      emailPlaceholder: 'tu@email.com',
      subject: 'Asunto',
      subjectPlaceholder: 'En qué podemos ayudarte',
      message: 'Mensaje',
      messagePlaceholder: 'Tu mensaje...',
      submit: 'Enviar Mensaje',
      submitting: 'Enviando...',
      success: '¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.',
      error: 'Algo salió mal. Por favor, inténtalo de nuevo.',
    },
    info: {
      phone: 'Teléfono',
      email: 'Correo Electrónico',
      location: 'Ubicación',
      locationValue: 'Fuerteventura, Islas Canarias',
    },
  },
  footer: {
    tagline: 'Transformando casas en hogares hermosos',
    quickLinks: 'Enlaces Rápidos',
    services: 'Servicios',
    packages: 'Paquetes',
    about: 'Nosotros',
    contact: 'Contacto',
    followUs: 'Síguenos',
    copyright: 'Todos los derechos reservados.',
    poweredBy: 'Desarrollado por Readdy',
  },
  renderService: {
    title: 'Servicio de Renderizado 3D',
    description: 'Proporcionamos un servicio de creación de renderizados 3D para tu casa, apartamento, villas, oficina y espacios comerciales. Ya sea interior o exterior, nuestros diseñadores trabajan con tus requisitos y entregan visualizaciones y renderizados detallados para que puedas dar una visión a tu hogar u oficina.',
    howItWorks: '¿Cómo Funciona?',
    pricing: 'Precios',
    pricingDescription: 'El precio comienza desde €350, pero varía según el tamaño, requisito y especificidad de los renderizados. Por favor, ponte en contacto con nosotros con tus requisitos.',
    getInTouch: 'Ponte en contacto:',
    renderedProjects: 'Nuestros Proyectos Renderizados',
    steps: {
      send: {
        title: 'Enviar Requisitos',
        description: 'Comparte tus imágenes, videos, planos de planta y estilos preferidos con referencias si es posible.',
      },
      design: {
        title: 'Diseñar y Crear',
        description: 'Nuestros diseñadores estudian el material y crean renderizados 3D detallados con múltiples opciones.',
      },
      delivery: {
        title: 'Entrega',
        description: 'Recibe tus renderizados de alta resolución en formato PDF en una semana.',
      },
    },
    priceRanges: [
      { range: '€250', description: 'Renderizado básico de habitación individual' },
      { range: '€500', description: 'Proyecto estándar de múltiples habitaciones' },
      { range: '€1,000', description: 'Apartamento/villa completo' },
      { range: '€1,500', description: 'Grandes espacios comerciales' },
      { range: 'Y Más', description: 'Proyectos personalizados complejos' },
    ],
    projects: {
      modernLiving: 'Espacio de Vida Moderno',
      contemporary: 'Interior Contemporáneo',
      luxuryKitchen: 'Diseño de Cocina de Lujo',
      officeSpace: 'Visualización de Espacio de Oficina',
    },
  },
  projectsCompleted: {
    title: 'Proyectos Completados',
    subtitle: 'Explora nuestro portafolio de proyectos completados exitosamente en Corralejo, mostrando nuestra experiencia en la transformación de diversos espacios.',
    projects: {
      cafeBarista: 'Café Barista',
      supermercado: 'Supermercado Deseos',
      coliving: 'Coliving',
      luxuryTerrace: 'Diseño de Terraza de Lujo',
    },
    location: 'Corralejo',
  },
};